import { mediaData } from '@/mocks/homeData';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=Anime%20PV%20teaser%20scene%20with%20dramatic%20lighting%20and%20action%20silhouettes%2C%20manga%20animation%20trailer%20aesthetic%2C%20warm%20coral%20and%20dark%20contrast%20tones%2C%20cinematic%20composition&width=640&height=400&seq=media-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Manga%20artist%20studio%20workspace%20with%20drawing%20tablet%2C%20scattered%20sketch%20papers%2C%20warm%20desk%20lamp%20lighting%2C%20creative%20atmosphere%2C%20cozy%20documentary%20photography%20style&width=640&height=400&seq=media-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Colorful%20anime%20new%20season%20compilation%20visual%20with%20various%20manga%20character%20silhouettes%2C%20vibrant%20warm%20tones%2C%20poster%20composition%2C%20Japanese%20anime%20magazine%20cover%20style&width=640&height=400&seq=media-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Manga%20fan%20meetup%20event%20photography%20with%20cosplay%20costumes%20and%20autograph%20signing%2C%20warm%20ambient%20lighting%2C%20joyful%20crowd%20atmosphere%2C%20convention%20hall%20setting&width=640&height=400&seq=media-04&orientation=landscape',
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-3">
            漫画视界
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            动画 PV、独家专访与精彩活动回顾
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaData.map((item, i) => (
            <div key={i} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[16/10] bg-background-200 overflow-hidden">
                <img
                  src={mediaImages[i]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-[10px] md:text-xs font-medium bg-background-50/90 text-foreground-800 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1 text-xs text-background-50/90">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}</span>
                </div>
              </div>

              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}